/* eslint-disable */
import CircleProgress from 'js-circle-progress';
import './x-circle-progress.scss';

window.isInViewport = function(element) {
  var rect = element.getBoundingClientRect();
  var html = document.documentElement;
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || html.clientHeight) &&
    rect.right <= (window.innerWidth || html.clientWidth)
  );
};

window.startAnimation = function(element) {
    if (window.isInViewport(element) && !element.fired) {
        const value = element.dataset.value;
        element.setAttribute('value', 0);
        element.updateGraph();
        element.setAttribute('value', value);
        element.fired = true;
    }
}

window.customElements.define('x-circle-progress', class extends CircleProgress {
  constructor() {
    super();
    this.content = this.innerHTML.trim();
    this.content = this.content.replace(/<strong/, '<strong style="font-weight:500"');
    this.innerHTML = '';
    this.shadowRoot.querySelector('svg')
      .insertAdjacentHTML('afterend', `<div class="circle-progress__content" part="content">${this.content}</div>`);
    this.textFormat = (value) => `${this.prefix}${value}${this.suffix}`;
    const self = this;
    if (this.image) {
      this.shadowRoot.querySelector('svg')
        .insertAdjacentHTML('beforeend', `<image part="image" x="30" y="23" width="40" height="22" href="${this.image}" />`);
      this.shadowRoot.querySelector('text').style.display = 'none';
    }
    window.addEventListener('scroll', () => { window.startAnimation(self) }, false);
    window.addEventListener('load', () => { window.startAnimation(self) }, false);
  }

  get prefix() {
    return this.getAttribute('prefix') ? this.getAttribute('prefix') : '';
  }

  set prefix(value) {
    this.setAttribute('prefix', value);
  }

  get suffix() {
    return this.getAttribute('suffix') ? this.getAttribute('suffix') : '';
  }

  set suffix(value) {
    this.setAttribute('suffix', value);
  }


  get image() {
    return this.getAttribute('image') ? this.getAttribute('image') : '';
  }

  set image(value) {
    this.setAttribute('image', value);
  }
});
